import { FC } from 'react';
import { ArrowCounterclockwise } from 'react-bootstrap-icons';
import styled from 'styled-components';

const Styled = styled(ArrowCounterclockwise)`
  background-color: #42ba96;
  color: #000;
  font-size: 1.4rem;
  border-radius: 50%;
  margin-top: 0.3rem;
  text-shadow: #000 1px 1px 1px;
  box-shadow: #555c 1px 1px 2px;
  cursor: pointer;
  &:hover {
    color: #fff;
  }
`;

const StyledResetButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  return <Styled onClick={onClick} />;
};

export default StyledResetButton;
